import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
    selector: 'kt-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss']
})
/**
 * Change password while the user have an expired password.
 * @note There's two components with the same name.
 * If you're looking for the component to change password once
 * the user is logged in check the following location:
 * app/views/pages/user-management/users/_subs/change-password
 */
export class ChangePasswordComponent implements OnInit {

    public user: string;

    constructor() { }

    ngOnInit() {
        this.user = window.location.search.slice('user='.length + 1);
    }

}
